module.exports = __webpack_public_path__ + "img/3.33add964.png";